import type { UIStringsOverride } from "../i18n-ui.ts";

/** Czech (cs) UI strings. */
export const cs: UIStringsOverride = {
  actions: {
    addToCursor: "Přidat do Cursoru",
    addToVscode: "Přidat do VS Code",
    askAI: "Zeptat se AI na tuto stránku",
    connectMcp: "Připojit k MCP",
    copied: "Zkopírováno!",
    copyClaudeCode: "Kopírovat příkaz Claude Code",
    copyCode: "Kopírovat kód",
    copyCodex: "Kopírovat příkaz Codex",
    copyMarkdown: "Kopírovat jako Markdown",
    copyServerUrl: "Kopírovat URL serveru",
    edit: "Upravit na GitHubu",
    export: "Exportovat",
    exportEpub: "Exportovat do EPUB",
    exportPdf: "Exportovat do PDF",
    generating: "Generování…",
    openIn: "Otevřít v {name}",
    openInChat: "Otevřít v chatu",
    scrollToTop: "Zpět nahoru",
  },
  ask: {
    ai: "AI",
    clear: "Vymazat konverzaci",
    close: "Zavřít",
    copy: "Kopírovat konverzaci",
    empty: "Zeptejte se na dokumentaci.",
    error: "Omlouváme se, něco se pokazilo.",
    label: "Položit otázku",
    placeholder: "Položit otázku…",
    send: "Odeslat",
    tip: "Tip: Chat můžete otevřít a zavřít pomocí",
    title: "Zeptat se AI",
    you: "Vy",
  },
  banner: { dismiss: "Zavřít oznámení" },
  changelog: {
    description: "Novinky produktu a poznámky k vydání.",
    showReleases: "Zobrazit vydání {version}",
    title: "Seznam změn",
  },
  content: { diagramError: "Tento diagram se nepodařilo vykreslit." },
  feedback: {
    no: "Ne",
    question: "Byla tato stránka užitečná?",
    thanks: "Děkujeme za zpětnou vazbu!",
    yes: "Ano",
  },
  languageSwitcher: { label: "Jazyk", untranslated: "Nepřeloženo" },
  nav: {
    back: "Zpět",
    breadcrumb: "Drobečková navigace",
    closeNavigation: "Zavřít navigaci",
    deprecated: "zastaralé",
    featured: "Doporučené",
    githubRepository: "Repozitář na GitHubu",
    navigation: "Navigace",
    primary: "Hlavní",
    sections: "Sekce",
    toggleNavigation: "Přepnout navigaci",
    toggleTheme: "Přepnout barevný motiv",
  },
  notFound: {
    description: "Stránku, kterou hledáte, se nepodařilo najít.",
    home: "Zpět na úvodní stránku",
    title: "Stránka nenalezena",
  },
  page: {
    lastUpdated: "Naposledy aktualizováno",
    next: "Další",
    pagination: "Stránkování",
    previous: "Předchozí",
    skipToContent: "Přejít k obsahu",
  },
  search: {
    all: "Vše",
    allLanguages: "Všechny jazyky",
    askAi: "Zeptat se AI",
    askAiHint: "Získejte okamžitou odpověď od AI",
    button: "Hledat",
    devOnly: "Vyhledávání je dostupné v produkčním buildu.",
    error: "Něco se pokazilo. Zkuste to prosím znovu.",
    label: "Prohledat dokumentaci",
    navigate: "navigace",
    noResults: "Nebyly nalezeny žádné výsledky.",
    open: "otevřít",
    placeholder: "Prohledat dokumentaci…",
    popular: "Populární",
    preview: "náhled",
    results: "Výsledky",
  },
  toc: { title: "Na této stránce" },
};
